module.exports = __webpack_public_path__ + "img/winerack34.ab67b927.jpg";